// Theme: forest-deep
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'forest-deep',
  name: 'FOREST DEEP',
  tagline: 'FOREST DEEP',
  description: 'Verde profundo de mata fechada em versao free BP com glow controlado.',
  category: 'organic-world',
  tier: 'rare',
  basePrice: 2625,
  swatches: ['#0F3C33', '#1A4F42', '#2DBA94', '#F2FFFB'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '10px',
      '--shadow-card': '0 10px 28px rgba(0, 0, 0, 0.22)',
      '--shadow-card-active': '0 10px 28px color-mix(in srgb, var(--primary) 35%, transparent)'
    },
    shellClasses: 'font-sans theme-forest-deep'
  },
  colorVars: {
    '--accent': '#2DBA94',
    '--accent-foreground': '#0F3C33',
    '--background': '#0F3C33',
    '--border': '#2A8A6A',
    '--card': '#1A4F42',
    '--card-border-active': 'rgba(45, 186, 148, 0.40)',
    '--card-completed': '#16463A',
    '--card-foreground': '#F2FFFB',
    '--card-glow': 'rgba(45, 186, 148, 0.06)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#0a0a0a',
    '--foreground': '#F2FFFB',
    '--hold-fill': '#2DBA94',
    '--input': '#2A8A6A',
    '--modal-bg': '#0F3C33',
    '--modal-border': '#2A8A6A',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 10px 28px rgba(0, 0, 0, 0.22)',
    '--muted': '#2A8A6A',
    '--muted-foreground': '#F2FFFB',
    '--nav-active': '#2DBA94',
    '--nav-bg': '#1A4F42',
    '--popover': '#1A4F42',
    '--popover-foreground': '#F2FFFB',
    '--primary': '#2DBA94',
    '--primary-foreground': '#0F3C33',
    '--ring': '#2DBA94',
    '--secondary': '#2A8A6A',
    '--secondary-foreground': '#F2FFFB',
    '--streak': '#2DBA94',
    '--success': '#22c55e',
    '--success-foreground': '#0F3C33',
    '--xp': '#2DBA94',
    '--xp-bg': '#1A4F42'
  },
  resolvedVars: {
    '--accent': '#2DBA94',
    '--accent-foreground': '#0F3C33',
    '--accent-foreground-hsl': '168 60% 15%',
    '--accent-foreground-oklch': 'from #0F3C33 l c h',
    '--accent-hsl': '164 61% 45%',
    '--accent-oklch': 'from #2DBA94 l c h',
    '--background': '#0F3C33',
    '--background-hsl': '168 60% 15%',
    '--background-oklch': 'from #0F3C33 l c h',
    '--border': '#2A8A6A',
    '--border-hsl': '160 53% 35%',
    '--border-oklch': 'from #2A8A6A l c h',
    '--border-w': '1px',
    '--card': '#1A4F42',
    '--card-border-active': 'rgba(45, 186, 148, 0.40)',
    '--card-completed': '#16463A',
    '--card-completed-hsl': '165 52% 18%',
    '--card-completed-oklch': 'from #16463A l c h',
    '--card-foreground': '#F2FFFB',
    '--card-foreground-hsl': '162 100% 97%',
    '--card-foreground-oklch': 'from #F2FFFB l c h',
    '--card-glow': 'rgba(45, 186, 148, 0.06)',
    '--card-hsl': '165 50% 21%',
    '--card-oklch': 'from #1A4F42 l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#0a0a0a',
    '--destructive-foreground-hsl': '0 0% 4%',
    '--destructive-foreground-oklch': 'from #0a0a0a l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #ef4444 l c h',
    '--foreground': '#F2FFFB',
    '--foreground-hsl': '162 100% 97%',
    '--foreground-oklch': 'from #F2FFFB l c h',
    '--hold-fill': '#2DBA94',
    '--hold-fill-hsl': '164 61% 45%',
    '--hold-fill-oklch': 'from #2DBA94 l c h',
    '--input': '#2A8A6A',
    '--input-hsl': '160 53% 35%',
    '--input-oklch': 'from #2A8A6A l c h',
    '--modal-bg': '#0F3C33',
    '--modal-bg-hsl': '168 60% 15%',
    '--modal-bg-oklch': 'from #0F3C33 l c h',
    '--modal-border': '#2A8A6A',
    '--modal-border-hsl': '160 53% 35%',
    '--modal-border-oklch': 'from #2A8A6A l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 10px 28px rgba(0, 0, 0, 0.22)',
    '--muted': '#2A8A6A',
    '--muted-foreground': '#F2FFFB',
    '--muted-foreground-hsl': '162 100% 97%',
    '--muted-foreground-oklch': 'from #F2FFFB l c h',
    '--muted-hsl': '160 53% 35%',
    '--muted-oklch': 'from #2A8A6A l c h',
    '--nav-active': '#2DBA94',
    '--nav-active-hsl': '164 61% 45%',
    '--nav-active-oklch': 'from #2DBA94 l c h',
    '--nav-bg': '#1A4F42',
    '--nav-bg-hsl': '165 50% 21%',
    '--nav-bg-oklch': 'from #1A4F42 l c h',
    '--popover': '#1A4F42',
    '--popover-foreground': '#F2FFFB',
    '--popover-foreground-hsl': '162 100% 97%',
    '--popover-foreground-oklch': 'from #F2FFFB l c h',
    '--popover-hsl': '165 50% 21%',
    '--popover-oklch': 'from #1A4F42 l c h',
    '--primary': '#2DBA94',
    '--primary-foreground': '#0F3C33',
    '--primary-foreground-hsl': '168 60% 15%',
    '--primary-foreground-oklch': 'from #0F3C33 l c h',
    '--primary-hsl': '164 61% 45%',
    '--primary-oklch': 'from #2DBA94 l c h',
    '--radius': '10px',
    '--ring': '#2DBA94',
    '--ring-hsl': '164 61% 45%',
    '--ring-oklch': 'from #2DBA94 l c h',
    '--secondary': '#2A8A6A',
    '--secondary-foreground': '#F2FFFB',
    '--secondary-foreground-hsl': '162 100% 97%',
    '--secondary-foreground-oklch': 'from #F2FFFB l c h',
    '--secondary-hsl': '160 53% 35%',
    '--secondary-oklch': 'from #2A8A6A l c h',
    '--shadow-card': '0 10px 28px rgba(0, 0, 0, 0.22)',
    '--shadow-card-active': '0 10px 28px color-mix(in srgb, var(--primary) 35%, transparent)',
    '--streak': '#2DBA94',
    '--streak-hsl': '164 61% 45%',
    '--streak-oklch': 'from #2DBA94 l c h',
    '--success': '#22c55e',
    '--success-foreground': '#0F3C33',
    '--success-foreground-hsl': '168 60% 15%',
    '--success-foreground-oklch': 'from #0F3C33 l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22c55e l c h',
    '--tint-primary-subtle': 'hsla(164 61% 45% / 0.15)',
    '--xp': '#2DBA94',
    '--xp-bg': '#1A4F42',
    '--xp-bg-hsl': '165 50% 21%',
    '--xp-bg-oklch': 'from #1A4F42 l c h',
    '--xp-hsl': '164 61% 45%',
    '--xp-oklch': 'from #2DBA94 l c h'
  }
}
